/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DishDto,
  DishSuggestionDto,
  SearchDishesParams,
  SuggestDishesParams
} from '../model';

import { apiFetch } from '../../lib/api-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getSearchDishesUrl = (params: SearchDishesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dishes/search?${stringifiedParams}` : `/api/dishes/search`
}

/**
 * Autocomplete for the manual-add flow. Matches Thai and English names in both directions, verified dishes first.
 * @summary Search the dish master table
 */
export const searchDishes = async (params: SearchDishesParams, options?: Parameters<typeof apiFetch>[1]): Promise<DishDto[]> => {

  return apiFetch<DishDto[]>(getSearchDishesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSearchDishesQueryKey = (params?: SearchDishesParams,) => {
    return [
    `/api/dishes/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchDishesQueryOptions = <TData = Awaited<ReturnType<typeof searchDishes>>, TError = unknown>(params: SearchDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDishes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchDishesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchDishes>>> = ({ signal }) => searchDishes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchDishes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SearchDishesQueryResult = NonNullable<Awaited<ReturnType<typeof searchDishes>>>
export type SearchDishesQueryError = unknown


export function useSearchDishes<TData = Awaited<ReturnType<typeof searchDishes>>, TError = unknown>(
 params: SearchDishesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDishes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDishes>>,
          TError,
          Awaited<ReturnType<typeof searchDishes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDishes<TData = Awaited<ReturnType<typeof searchDishes>>, TError = unknown>(
 params: SearchDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDishes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof searchDishes>>,
          TError,
          Awaited<ReturnType<typeof searchDishes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSearchDishes<TData = Awaited<ReturnType<typeof searchDishes>>, TError = unknown>(
 params: SearchDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDishes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Search the dish master table
 */

export function useSearchDishes<TData = Awaited<ReturnType<typeof searchDishes>>, TError = unknown>(
 params: SearchDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof searchDishes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSearchDishesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getSuggestDishesUrl = (params: SuggestDishesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/dishes/suggest?${stringifiedParams}` : `/api/dishes/suggest`
}

/**
 * Answers "I have about N kcal to spend — what should I eat": the 5 dishes whose serving lands closest to N, nearest first, each with the gap to N so the user can judge the fit. Never an empty list while the dish table has rows — a distant match is still an answer, and the gap says so.
 * @summary Dishes to eat for roughly a given number of calories
 */
export const suggestDishes = async (params: SuggestDishesParams, options?: Parameters<typeof apiFetch>[1]): Promise<DishSuggestionDto[]> => {

  return apiFetch<DishSuggestionDto[]>(getSuggestDishesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getSuggestDishesQueryKey = (params?: SuggestDishesParams,) => {
    return [
    `/api/dishes/suggest`, ...(params ? [params] : [])
    ] as const;
    }


export const getSuggestDishesQueryOptions = <TData = Awaited<ReturnType<typeof suggestDishes>>, TError = unknown>(params: SuggestDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestDishes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSuggestDishesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof suggestDishes>>> = ({ signal }) => suggestDishes(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof suggestDishes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type SuggestDishesQueryResult = NonNullable<Awaited<ReturnType<typeof suggestDishes>>>
export type SuggestDishesQueryError = unknown


export function useSuggestDishes<TData = Awaited<ReturnType<typeof suggestDishes>>, TError = unknown>(
 params: SuggestDishesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestDishes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof suggestDishes>>,
          TError,
          Awaited<ReturnType<typeof suggestDishes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSuggestDishes<TData = Awaited<ReturnType<typeof suggestDishes>>, TError = unknown>(
 params: SuggestDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestDishes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof suggestDishes>>,
          TError,
          Awaited<ReturnType<typeof suggestDishes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useSuggestDishes<TData = Awaited<ReturnType<typeof suggestDishes>>, TError = unknown>(
 params: SuggestDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestDishes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Dishes to eat for roughly a given number of calories
 */

export function useSuggestDishes<TData = Awaited<ReturnType<typeof suggestDishes>>, TError = unknown>(
 params: SuggestDishesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof suggestDishes>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSuggestDishesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






